module.exports = __webpack_public_path__ + "img/product-s618-4000-1.176e49cf.png";